import React from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import StaticBanner from '../../../components/elements/StaticBanner';
import BannerImg from '../../../../public/assets/images/BannersFiles/28.jpg';
import { useLocation } from 'react-use';
import { PageHitCountApi } from '../../../shared/Helper';
const Volunteer_us = () => {
  const { t } = useTranslation();
  const isActive = useSelector((state) => state.toggle.isActive);
  const { pathname } = useLocation();

  useEffect(() => {
    localStorage.setItem('isHome', true);
    PageHitCountApi(pathname, 0);
  }, []);

  return (
    <>
      <div className="">
        <StaticBanner en_US={'Volunteer_us'} BannerImg={BannerImg} arabic={false} />

        <section
          className={`py-5 sm:h-90 flex xl:flex-row flex-col px-10  xl:px-20 ${isActive ? 'text-left' : 'text-right'}`}
        >
          <img src={`/assets/images/1234.png`} className="pb-4    md:max-w-screen-sm" alt="" />
          <div className="pt-2 xl:px-10 flex flex-col justify-center items-center align-middle ">
            <h4 className={`text-customgreen flex sm:text-2xl items-center leading-10 text-justify pt-1 sm:pb-3  `}>
              {isActive
                ? `نهدف إلى تطوير ودعم بناء قدرات المتطوعين والمبادرات الإنسانية في جميع المجالات والتوعية بأهميتها في النهوض بالمجتمع وخلق غد أفضل في إطار منظم ، ومنصة للتوعية المجتمعية والإنسانية ، من خلال تنمية الشباب وتفجير الطاقات الإبداعية فيهم ، ليكونوا قادة لمستقبل واعد وطموح ، ويساهمون في الحفاظ على القيم و مبادئ المجتمع من خلال القنوات الصحيحة والأسس المتينة والمستقيمة.

التالي: إجراء الخدمة
`
                : `We aim to develop and support the capacities of volunteers and humanitarian initiatives in all fields and raise awareness of their importance in advancing society and creating a better tomorrow. Our platform is dedicated to community and humanitarian awareness, fostering youth development, and unlocking their creative potential to become future leaders who uphold the values and principles of society through proper channels and solid foundations.

Next: Service Procedure`}
            </h4>
            <Link to={'/donorLogin'}>
              <button
                type="submit"
                className="text-white mx-1 w-32 bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-5 py-2.5 text-center"
              >
                {t('login')}
              </button>
            </Link>
          </div>
        </section>
      </div>
    </>
  );
};

export default Volunteer_us;
